import { render, staticRenderFns } from "./SignatureCanvas.vue?vue&type=template&id=0446c218&scoped=true&"
import script from "./SignatureCanvas.vue?vue&type=script&lang=ts&"
export * from "./SignatureCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./SignatureCanvas.vue?vue&type=style&index=0&id=0446c218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446c218",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
